interface NovuResult<T> {
  data?: T;
  error?: Error;
}

/**
 * Novu SDK calls resolve `{ data, error }` instead of rejecting, so a plain `await`
 * lets a failed call fall through to the optimistic UI update as though it had worked.
 */
export const unwrapNovuResult = <T>(result: NovuResult<T> | undefined) => {
  if (!result) return undefined;
  if (result.error) throw result.error;
  return result.data;
};
